export const SET_APPOINTMENT_DASHBOARD_VALUE = 'SET_APPOINTMENT_DASHBOARD_VALUE'
export const SET_SCHEDULES = 'SET_SCHEDULES'
export const SET_BOOKING_STATUS = 'SET_BOOKING_STATUS'
export const CLEAR_SELECTED_APPOINTMENT = 'CLEAR_SELECTED_APPOINTMENT'
export const CLEAR_BOOKING_STATUS = 'CLEAR_BOOKING_STATUS'
export const APPOINTMENT_DATA_LOADED = 'APPOINTMENT_DATA_LOADED'
